<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="所属广告平台" prop="advertPlatform">
          <el-input v-model="dataForm.advertPlatform" placeholder="所属广告平台"></el-input>
      </el-form-item>
          <el-form-item label="广告主账号" prop="advertiserId">
          <el-input v-model="dataForm.advertiserId" placeholder="广告主账号"></el-input>
      </el-form-item>
          <el-form-item label="广告主名称" prop="advertiserName">
          <el-input v-model="dataForm.advertiserName" placeholder="广告主名称"></el-input>
      </el-form-item>
          <el-form-item label="联系邮箱" prop="email">
          <el-input v-model="dataForm.email" placeholder="联系邮箱"></el-input>
      </el-form-item>
          <el-form-item label="账户总余额(单位元)" prop="balance">
          <el-input v-model="dataForm.balance" placeholder="账户总余额(单位元)"></el-input>
      </el-form-item>
          <el-form-item label="账户可用总余额(单位元)" prop="validBalance">
          <el-input v-model="dataForm.validBalance" placeholder="账户可用总余额(单位元)"></el-input>
      </el-form-item>
          <el-form-item label="现金余额(单位元)" prop="cash">
          <el-input v-model="dataForm.cash" placeholder="现金余额(单位元)"></el-input>
      </el-form-item>
          <el-form-item label="账户总余额(单位元)" prop="validCash">
          <el-input v-model="dataForm.validCash" placeholder="账户总余额(单位元)"></el-input>
      </el-form-item>
          <el-form-item label="赠款余额(单位元)" prop="grant">
          <el-input v-model="dataForm.grantss" placeholder="赠款余额(单位元)"></el-input>
      </el-form-item>
          <el-form-item label="默认广告位可用赠款余额(单位元)" prop="defaultGrant">
          <el-input v-model="dataForm.defaultGrant" placeholder="默认广告位可用赠款余额(单位元)"></el-input>
      </el-form-item>
          <el-form-item label="通用广告位可用赠款余额(单位元)" prop="commonGrant">
          <el-input v-model="dataForm.commonGrant" placeholder="通用广告位可用赠款余额(单位元)"></el-input>
      </el-form-item>
          <el-form-item label="搜索广告位可用赠款余额(单位元)" prop="searchGrant">
          <el-input v-model="dataForm.searchGrant" placeholder="搜索广告位可用赠款余额(单位元)"></el-input>
      </el-form-item>
          <el-form-item label="穿山甲广告位可用赠款余额(单位元)" prop="unionGrant">
          <el-input v-model="dataForm.unionGrant" placeholder="穿山甲广告位可用赠款余额(单位元)"></el-input>
      </el-form-item>
          <el-form-item label="赠款可用余额(单位元)" prop="validGrant">
          <el-input v-model="dataForm.validGrant" placeholder="赠款可用余额(单位元)"></el-input>
      </el-form-item>
          <el-form-item label="返货余额(单位元)" prop="returnGoodsAbs">
          <el-input v-model="dataForm.returnGoodsAbs" placeholder="返货余额(单位元)"></el-input>
      </el-form-item>
          <el-form-item label="返货可用余额(单位元)" prop="validReturnGoodsAbs">
          <el-input v-model="dataForm.validReturnGoodsAbs" placeholder="返货可用余额(单位元)"></el-input>
      </el-form-item>
          <el-form-item label="返货支出(单位元)" prop="returnGoodsCost">
          <el-input v-model="dataForm.returnGoodsCost" placeholder="返货支出(单位元)"></el-input>
      </el-form-item>
          <el-form-item label="状态（开1、关0）" prop="status">
          <el-input v-model="dataForm.status" placeholder="状态（开1、关0）"></el-input>
      </el-form-item>
          <el-form-item label="创建人" prop="createdBy">
          <el-input v-model="dataForm.createdBy" placeholder="创建人"></el-input>
      </el-form-item>
          <el-form-item label="修改人" prop="updatedBy">
          <el-input v-model="dataForm.updatedBy" placeholder="修改人"></el-input>
      </el-form-item>
          <el-form-item label="创建时间" prop="createTime">
          <el-input v-model="dataForm.createTime" placeholder="创建时间"></el-input>
      </el-form-item>
          <el-form-item label="修改时间" prop="updateTime">
          <el-input v-model="dataForm.updateTime" placeholder="修改时间"></el-input>
      </el-form-item>
          <el-form-item label="删除时间" prop="deleteTime">
          <el-input v-model="dataForm.deleteTime" placeholder="删除时间"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        advertPlatform: '',
        advertiserId: '',
        advertiserName: '',
        email: '',
        balance: '',
        validBalance: '',
        cash: '',
        validCash: '',
        grantss: '',
        defaultGrant: '',
        commonGrant: '',
        searchGrant: '',
        unionGrant: '',
        validGrant: '',
        returnGoodsAbs: '',
        validReturnGoodsAbs: '',
        returnGoodsCost: '',
        status: '',
        createdBy: '',
        updatedBy: '',
        createTime: '',
        updateTime: '',
        deleteTime: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        advertPlatform: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        advertiserId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        advertiserName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        email: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        balance: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        validBalance: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        cash: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        validCash: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        grantss: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        defaultGrant: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        commonGrant: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        searchGrant: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        unionGrant: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        validGrant: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        returnGoodsAbs: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        validReturnGoodsAbs: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        returnGoodsCost: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        createdBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updatedBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        createTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleteTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/rdaccount/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/rdaccount/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
